import { render, staticRenderFns } from "./WebView.vue?vue&type=template&id=5820870d&scoped=true&"
import script from "./WebView.vue?vue&type=script&lang=js&"
export * from "./WebView.vue?vue&type=script&lang=js&"
import style0 from "./WebView.vue?vue&type=style&index=0&id=5820870d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820870d",
  null
  
)

export default component.exports